import React from "react";

let sass = [];

export default class StyleInjector extends React.Component {

    componentDidMount() {
        this.regen();
    }

    loadStyle = (scss) => {
        if (scss) {
            if (typeof window !== 'undefined' && typeof document !== 'undefined') {
                if (typeof Sass === 'undefined' || typeof Sass.compile !== 'function') {
                    const sassJSScript = document.createElement('script');
                    sassJSScript.type = 'text/javascript';
                    sassJSScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/sass.js/0.9.12/sass.sync.min.js';
                    sassJSScript.onload = () => {
                        (sass || []).map((s) => s());
                        sass = false;
                    };
                    document.head.appendChild(sassJSScript);
                } else if(sass) {
                    sass.map((s) => s());
                }
            }
        }
        let cancel = false;
        const p = new Promise((resolve, reject) => {
            const s = () => {
                Sass.compile("." + this.props.id + "{" + (scss || '') + "}", (result) => {
                    if (result.message) {
                        console.error(result.message);
                    }
                    if (cancel) return;
                    resolve(result.text || '');
                });
            };
            if (sass !== false) {
                sass.push(s);
            } else {
                s();
            }
        });
        p.abort = () => {cancel = true;};
        return p;
    }

    regen = () => {
        if (!this.styleTag) {
            this.styleTag = document.querySelector("style[style-injector-id='" + this.props.id + "']");
            if (!this.styleTag) {
                this.styleTag = document.createElement("style");
                document.body.appendChild(this.styleTag);
                this.styleTag.setAttribute("style-injector-id", this.props.id);
                this.styleTag.setAttribute("type", "text/css");
            }
        }
        this.styleCompiler && this.styleCompiler.abort();
        this.styleCompiler = this.loadStyle(this.props.style);
        this.styleCompiler.then((styleCompiled) => {
            if (this.styleTag) {
                this.styleTag.innerHTML = styleCompiled;
            }
        });
    }

    componentWillUnmount() {
        if (this.styleTag) {
            this.styleTag.parentNode.removeChild(this.styleTag);
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (prevProps.style + "" !== "" + this.props.style || this.props.id + "" !== "" + prevProps.id) {
            if (this.props.id + "" !== "" + prevProps.id) {
                const t = document.querySelector("style[style-injector-id='" + prevProps.id + "']");
                t && t.parentNode.removeChild(t);
                this.styleTag = null;
            }
            this.regen();
        }
    }

    render() {
        return null;
    }
}